import React from 'react';

import { Row, Col } from 'wix-style-react';
import { SectionTitle } from '../SectionTitle/SectionTitle';

export interface CrmHomeSectionProps {
  title: string;
  titleDataHook: string;
  actionTitle?: string;
  actionOnClick?(): void;
}

export const CrmHomeSection: React.FC<CrmHomeSectionProps> = (props) => {
  return (
    <Row>
      <Col>
        <SectionTitle
          title={props.title}
          dataHook={props.titleDataHook}
          actionOnClick={props.actionOnClick}
          actionTitle={props.actionTitle}
        />
        {props.children}
      </Col>
    </Row>
  );
};
